import { render, staticRenderFns } from "./PopoverEvent.vue?vue&type=template&id=eb4bb27c&"
import script from "./PopoverEvent.vue?vue&type=script&lang=js&"
export * from "./PopoverEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports